import React from "react";
import styled from "styled-components";
import Skeleton from "common/NewLook/Skeleton.tsx";
import { NEW_LOOK_BOT_CARD as CARD } from "features/bots/NewLook/newLookBotUtils";
import { newLookCardSurface } from "features/bots/NewLook/newLookStyles";
import { getNewLookTokens } from "common/NewLook/tokens.ts";

/**
 * New look: a placeholder with the bot card's frame (header, headline, the
 * main visual, footer), shown while the bots load for the first time so
 * nothing jumps.
 */
const NewLookBotCardSkeleton = () => (
  <Card aria-hidden={true}>
    <Head>
      <Skeleton
        width={CARD.logo}
        height={CARD.logo}
        radius={CARD.logoRadius}
        style={NO_SHRINK}
      />
      <Column>
        <Skeleton width="55%" height={12} />
        <Skeleton width="70%" height={10} />
      </Column>
    </Head>
    <Body>
      <Column>
        <Skeleton width={120} height={26} />
        <Skeleton width="52%" height={10} />
      </Column>
      <Skeleton width="100%" height={CARD.chartHeight} radius={8} />
    </Body>
    <Foot>
      <Skeleton width="45%" height={10} />
      <Skeleton width={44} height={10} style={END} />
    </Foot>
  </Card>
);

export default React.memo(NewLookBotCardSkeleton);

const NO_SHRINK = { flex: "none" };
const END = { marginLeft: "auto" };

const Card = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${newLookCardSurface};
  border-radius: ${CARD.radius}px;
`;
const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: ${CARD.paddingTop}px ${CARD.padding}px 0;
`;
const Column = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 18px ${CARD.padding}px ${CARD.paddingBottom}px;
`;
const Foot = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: auto;
  padding: 14px ${CARD.padding}px;
  border-top: 1px solid ${(p) => getNewLookTokens(p.theme).hairline};
`;
